import { gql, useMutation } from '@apollo/client';

import type {
  UpdateDependantContactMutation,
  UpdateDependantContactMutationVariables,
} from './__generated__/useUpdateDependantContact.gql';

const UPDATE_DEPENDANT_CONTACT = gql`
  mutation UpdateDependantContact($input: UpdateDependantInput!) {
    updateDependant(input: $input) {
      id
      email
      phoneNumber
    }
  }
`;

/**
 * Edit a dependant's email + phone columns. Distinct from
 * `useUpdateDependant` (which projects the firstName / lastName / dob
 * fields used by `DependantEntryStep`) — both call the same backend
 * `updateDependant` mutation, but each hook returns the projection its
 * consumer cares about. Apollo merges the response into the existing
 * `Dependant:<id>` cache record, so `useOnboardingDependants` consumers
 * pick up the new contact values automatically.
 *
 * @returns The standard `useMutation` tuple — `[mutate, MutationResult]`
 *   where `MutationResult.loading` / `.error` / `.data` track the
 *   in-flight call.
 */
export const useUpdateDependantContact = () => {
  return useMutation<UpdateDependantContactMutation, UpdateDependantContactMutationVariables>(UPDATE_DEPENDANT_CONTACT);
};
